export const GET_ADMIN_ACCESS_REQUEST = 'GET_ADMIN_ACCESS_REQUEST';
export const GET_ADMIN_ACCESS_SUCCESS = 'GET_ADMIN_ACCESS_SUCCESS';
export const GET_ADMIN_ACCESS_FAIL = 'GET_ADMIN_ACCESS_FAIL';

export const getAdminAccessRequest = () => ({
  type: GET_ADMIN_ACCESS_REQUEST,
});

